module.exports = __webpack_public_path__ + "img/token-info-header-dark.4aae2272.png";